import React from 'react'
import { ViewStyle } from 'react-native'
import type { WBIRecomendation, WBIAction } from '@dialogue/services/dist/recommender/model'

import { CompareChart } from '../Charts'
import DefaultRecommendation from './DefaultRecommendation'

interface CompareRecommendationProps {
  score: number
  recommendation: WBIRecomendation['recommendation']
  actions: WBIRecomendation['actions']
  onActionPress?: (action: WBIAction) => void
  style?: ViewStyle
}

const CompareRecommendation = (props: CompareRecommendationProps) => (
  <>
    <CompareChart score={props.score} />
    {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
    <DefaultRecommendation {...(props as any)} />
  </>
)

export default CompareRecommendation
